import { render, staticRenderFns } from "./ContratacionRegimenes.vue?vue&type=template&id=fc3652c4"
import script from "./ContratacionRegimenes.vue?vue&type=script&lang=js"
export * from "./ContratacionRegimenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports